import FilterPrice from "./FilterPrice";

export default FilterPrice;
